import React from 'react';
import { motion } from 'framer-motion';
import { useAdminStore } from '@/lib/admin-store';
import { useTranslation } from '@/hooks/useTranslation';

const TeamPage: React.FC = () => {
  const { t, localize } = useTranslation();
  const settings = useAdminStore((s) => s.settings);
  const teamMembers = useAdminStore((s) => s.teamMembers);

  return (
    <div className="min-h-screen pt-24 sm:pt-32 pb-20 px-4 sm:px-6 md:px-24">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-10 sm:mb-20"
        >
          <h1 className="text-3xl sm:text-5xl md:text-8xl font-syncopate font-bold text-black dark:text-white uppercase tracking-tighter leading-none">
            {t.team.title}
          </h1>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-16">
          {teamMembers.map((member, i) => (
            <motion.div
              key={member._id}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.15, duration: 0.8 }}
              className="space-y-6"
            >
              <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-[#f9f9f9] dark:bg-[#0a0a0a] border border-black/5 dark:border-white/5">
                {member.photo ? (
                  <img
                    src={member.photo}
                    alt={localize(member.name)}
                    className="w-full h-full object-cover grayscale-[0.3] hover:grayscale-0 transition-all duration-700"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-black/10 dark:text-white/10">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                  </div>
                )}
              </div>
              <div>
                <h3 className="text-xl font-syncopate font-bold text-black dark:text-white uppercase tracking-tighter">
                  {localize(member.name)}
                </h3>
                <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-black/30 dark:text-white/30 mt-2">
                  {localize(member.role)}
                </p>
                <p className="text-sm text-black/50 dark:text-white/50 font-light mt-4 leading-relaxed whitespace-pre-line text-justify">
                  {localize(member.bio)}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamPage;
